import * as React from 'react';

import { MetricValuePill, SparkLine } from '@tableau/metrics-shared-widgets-dom';

import { getMeasureFormat, getMetricMeasure } from '..';
import { cssClass } from '../../style';
import { IMetricDataInfo } from '../models/IMetricInfo';

export type MetricSparklineAndPillProps = {
    readonly metricData: IMetricDataInfo;
};

export class MetricSparklineAndPill extends React.PureComponent<MetricSparklineAndPillProps> {
    public render(): JSX.Element {
        let measure;
        let format;

        if (this.props.metricData && this.props.metricData.dataPoints && this.props.metricData.dataPoints.length > 0) {
          measure = getMetricMeasure(this.props.metricData);
          format = getMeasureFormat(this.props.metricData);
        }

        const showSparkline = this.props.metricData && this.props.metricData.dataPoints && this.props.metricData.dataPoints.length > 1;

        return (
        <div data-tb-test-id="omnibox-metric-thumbnail">
            <span className={MetricOmniPillStyle} data-tb-test-id="omnibox-metric-pill">
              <MetricValuePill value={measure} measureFormat={format} />
            </span>
            {
              showSparkline &&
              <SparkLine
                size={MetricOmniSparklineSize}
                data={this.props.metricData.dataPoints.slice(-30)}  // 100 points is still kind of slow so use only 30
                style={MetricOmniSparklineStyle}
                testId={'omnibox-metric-sparkline'}
              />
            }
            {
              !showSparkline && <div style={{...MetricOmniSparklineStyle, ...MetricOmniSparklineSize}} />
            }
        </div>);
    }
}

const thumbnailWidth = 76;
const sparklineHeight = 18;

const MetricOmniPillStyle = cssClass('omni', 'metric-pill', {
  display: 'flex',
  flexGrow: 1,
  flexDirection: 'row',
  paddingTop: 8,
  alignItems: 'center',
  justifyContent: 'center',
  width: thumbnailWidth + 'px',
  height: '20px',
});

const MetricOmniSparklineStyle = {paddingTop: '8px', paddingBottom: '8px'};
const MetricOmniSparklineSize = { width: thumbnailWidth, height: sparklineHeight};
